class MyWeeklyPicksExceptionController {
    constructor(shopperService, settings, categoriesService) {
        this.shopperService = shopperService;
        this.settings = settings;
        this.categoriesService = categoriesService;
    }

    $onInit() {
        this.breadcrumbs = this.categoriesService.getCategoryPathToToRootByNodeId(this.category.NodeId);
    }
}

const myWeeklyPicksExceptionComponentDefinition = {
    bindings: {
        category: '<',
    },
    controller: ['ShopperService', 'Settings', 'CategoriesService', MyWeeklyPicksExceptionController],
    template: require('./my-weekly-picks-exception.component.html').trim(),
};

module.exports = {
    MyWeeklyPicksExceptionController,
    myWeeklyPicksExceptionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/browse/my-weekly-picks-exception.component.js